var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009a00",
    fillRule: "evenodd",
    d: "M.3 0h60v12.5H.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.3 12.5h60v1.3H.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M.3 13.8h60v12.5H.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.3 26.3h60v1.2H.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffca00",
    fillRule: "evenodd",
    d: "M.3 27.5h60V40H.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M.3 0v40l26.3-20z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffca00",
    fillRule: "evenodd",
    d: "m15.8 26-4-3-4 3 1.6-4.7-4-2.9h5l1.4-4.7 1.6 4.7h5l-4.1 2.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M8.4 22.7h2.9q.4.5 1.2 0c.9-.5 2.6 0 2.6 0l.4-.3-.8-2.8-.4-.3s-.6-.4-1.8-.3q-1.8.2-1.7 0s-1 .1-1.4.3l-.3.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M9 22s2.7-.3 3.5.7q-.6.5-1.3 0s1-1 3.4-.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M11.9 19.3v3m2.4-3 .6 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m9.5 19.3-.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m6.5 23 .7.9h.2l1-1.3.4-.5.1-.2.8-.7h.2q-.2 0-.1-.2l.2-.1.1.2-.2.2h-.2l-.4.4.2.2.2.7.4-.2-.3-.8.5-.5-.2-.3.2-.1s1.6 1 2.3.7v-.7s-1.7-.2-1.8-.5c0-.4.4-.4.4-.4l-.1-.3v-.1l.3.4.7-.6 4 4.6q.3-.1.3-.4l-4-4.5.3-.4.1-.2.5-.4.3.3 1.3-1h.2l2-2-2.2 1.5h-.1v-.2h-.2s-.4 0-.4-.2v.4l-.6.5H13l-.6.6-.1.3v.2l-.3.3v-.1l.3-.3v-.3l-.5.3-1.1-1.2v-.2l-.6-.7q-.6-.2-.8.4h-.8L7 18.9l.9 1 1.8-2.2V17l.4.4h.4l1 1.1-.1.2.1.2.2-.1h0q0 .2-.2.2l-.2-.4-.6.5v.1l-1.8 1.5h-.2v.5l1.1-1v-.1l.1.1 1-.7q0 0 0 0l-.8.8h0l-.2.2h0l-1.1.9h-.2L8 22l-.4.1z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMz);
export default __webpack_public_path__ + "static/media/mz.2fe092df69ce5febdba98a7dde1e3639.svg";
export { ForwardRef as ReactComponent };